import Vue from 'vue'
import ConfirmBox from './ConfirmBox.vue'

const confirmBox = Vue.extend(ConfirmBox)

ConfirmBox.install = function (options, type) {
  if (options === undefined || options === null) {
    options = {
      content: ''
    }
  } else if (typeof options === 'string' || typeof options === 'number') {
    options = {
      content: options
    }
    if (type != undefined && options != null) {
      options.type = type;
    }
  }

  let instance = new confirmBox({
    data: options
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.visible = true
  })
}

export default ConfirmBox


// WEBPACK FOOTER //
// ./src/components/MessageBox/confirmBox.js